import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {PanelsService} from '@ispm/layout/services/panels.service';
import {PanelLoaderPayload} from '@ispm/layout/classes/panel-loader-payload.abstract';
import {ModelApprovalComponent} from '@ispm-client/modules/bpmn-modeler/model-approval.component/model-approval.component';


@Injectable()
export class ModelApprovalPanelService {

  static readonly BpmnApprovalPanelName = 'bpmnApprovalPanel';

  constructor(private panelService: PanelsService) {
  }

  public openApprovalPanel(config, data, approveCallback: (...args) => void): Observable<any> {
    return this.openPanel(ModelApprovalComponent, config, data, approveCallback);
  }

  public closePanel(): Observable<any> {
    this.panelService.hideLayout(ModelApprovalPanelService.BpmnApprovalPanelName);
    return Observable.empty();
  }

  private openPanel(component: any, config, data, approveCallback: (...args) => void, shifted: boolean = false): Observable<any> {
    const definition = PanelLoaderPayload.builder()
      .setTitle(config.label)
      .setPayload({data: data, config: config, shifted: config.shiftUsed})
      .setApproveCallback(approveCallback);
    return this.panelService.showLayout(component, definition, ModelApprovalPanelService.BpmnApprovalPanelName);
  }
}
